import React from 'react'
import ReactDOM from 'react-dom'

import sagas from 'Redux/sagas'
import reducers from 'Redux/reducers'

import App from '@antegma/accallio-cloud-react-components/lib/app/'
import { TRouterProps } from '@antegma/accallio-cloud-react-components/lib/app/router'

import * as languages from 'Assets/languages'
import pages from '~/pages'
import * as serviceWorker from './serviceWorker'

import 'Assets/global.scss'

const router: TRouterProps = {
  indexUrl: '/manage',
  pages,
}

const redux = {
  sagas,
  reducers,
}

ReactDOM.render(<App languages={languages} name="Cloud Admin" router={router} hideTenantSwitch redux={redux} />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
